var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 6,
    height: 12,
    viewBox: "0 0 6 12",
    fill: "current",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.8344 6.1656C5.83478 6.36031 5.76696 6.54901 5.64273 6.69894L1.47606 11.6989C1.18151 12.0533 0.655445 12.1018 0.301063 11.8073C-0.0533201 11.5127 -0.101823 10.9867 0.192729 10.6323L3.92606 6.1656L0.326064 1.69894C0.186255 1.52678 0.12084 1.30599 0.144301 1.08545C0.167762 0.864917 0.278164 0.662831 0.451064 0.523937C0.62428 0.369659 0.853962 0.294558 1.08486 0.316699C1.31576 0.338841 1.52699 0.45622 1.66773 0.640603L5.69273 5.6406C5.79733 5.79484 5.8472 5.97969 5.8344 6.1656Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRight);
export default __webpack_public_path__ + "static/media/arrow-right.4f1e4deeeb84997dc15c7e460219f3dd.svg";
export { ForwardRef as ReactComponent };